import React, {Component} from "react";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import MasterPromoHeader from "./masterPromoHeader";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {getTableDetailUnitConfig} from "../config";
import {defaultTableChange, defaultTableChangePromo} from "../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import MasterPromoTambahUnit from "./masterPromoTambahUnit";
import * as R from "ramda";
import {fetchDataAsync} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import {ACTIVITY_TYPE, HttpStatus} from "../../../common/Constants";
import {mapToObjectDDL} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleInput from "../../../../modules/SimpleInput";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import _ from 'lodash';
import {saveAs} from 'file-saver'
class MasterPromoModifying extends Component {
    actionColumn = [
        {
            name: "",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <FlexView style={{gap: "10px"}}>
                        <SimpleButton
                            type="button"
                            category="action_button"
                            style={{backgroundColor: "transparent"}}
                            icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-pencil-alt"/>}
                            onClick={() => this.handleChangeDetailUnit(rowIndex)}
                        />
                        <SimpleButton
                            type="button"
                            category="action_button"
                            style={{backgroundColor: "transparent"}}
                            icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-times"/>}
                            onClick={() => this.handleDeleteUnit(rowIndex)}
                        />
                    </FlexView>
                ),
            }
        }
    ]

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tableColumn: [],
            addVisible: false,
            uploadVisible: false,
            file: null,
            selectedData: null,
            selectedIndex: null,
            sortOrder: null, 
            loadLeasing: false,
            alert: {
                visible: false,
                content: null,
                type: null
            },
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
        this.fileInputRef = React.createRef();
    }

    componentDidMount = async () => {
        let viewOnly = this.props.activityType === ACTIVITY_TYPE.VIEW;
        let promoType = R.isEmpty(this.props.controls.promoType?.value) || R.isNil(this.props.controls.promoType?.value);
        let tab = promoType ? this.props.tab : this.props.controls?.promoType?.value?.value.toLowerCase();
        let tableColumn = viewOnly ? getTableDetailUnitConfig(tab) : [...getTableDetailUnitConfig(tab), ...this.actionColumn];
        this.setState((prevValue) => ({
            ...prevValue,
            tableColumn,
        }))

        if (this.props.initialValues) {
            this.handleTriggerLoading();
            await this.fetchData();
            this.handleTriggerLoading();
        }

        if (this.props.activityType === ACTIVITY_TYPE.CREATE || this.props.activityType === "COPY") {
            this.handleTriggerLoading();
            await this.fetchDataPreviewId();
            if (this.props.activityType === ACTIVITY_TYPE.CREATE)
                this.props.setValue("dataUnit", []);
            this.handleTriggerLoading();
        }
    };

    componentDidUpdate = (prevProps) => {
        if (prevProps.controls.promoType.value?.value !==  this.props.controls.promoType?.value?.value) {
            let viewOnly = this.props.activityType === ACTIVITY_TYPE.VIEW;
            let promoType = R.isEmpty(this.props.controls.promoType?.value) || R.isNil(this.props.controls.promoType?.value);
            let tab = promoType ? this.props.tab : this.props.controls?.promoType?.value?.value.toLowerCase();
            let tableColumn = viewOnly ? getTableDetailUnitConfig(tab) : [...getTableDetailUnitConfig(tab), ...this.actionColumn];
            this.setState((prevValue) => ({
                ...prevValue,
                tableColumn,
            }));
            if (this.props.controls.promoType?.value === "CASH") {
                this.props.setValue("leasingId", null);
            }
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.props.customValidate(this.validate(this.props.controls))) {
            this.props.onSubmit(this.props.controls);
        }
    };

    handleChangeDetailUnit = (rowIndex) => {
        const dt = this.getSortedData() || []
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: dt[rowIndex],
            selectedIndex: rowIndex,
            addVisible: !prevValue.addVisible,
        }))
    };

    validate = (controls) => {
        const newErrors = {};
        const applied = controls.applied?.value;
        const cabang = controls.cabang?.value;
        const wilayah = controls.wilayah?.value;
        const promoType = controls.promoType?.value.value;
        const leasingId = controls.leasingId?.value;
        const dataUnit = controls.dataUnit?.value;

        if (applied === "CABANG" && (R.isNil(cabang) || R.isEmpty(cabang))) {
            newErrors["cabang"] = "Field belum diisi";
        }

        if (applied === "WILAYAH" && (R.isNil(wilayah) || R.isEmpty(wilayah))) {
            newErrors["wilayah"] = "Field belum diisi";
        }

        if (promoType === "CREDIT" && (R.isNil(leasingId) || R.isEmpty(leasingId))) {
            newErrors["leasingId"] = "Field belum diisi";
        }

        if (R.isEmpty(dataUnit)) {
            newErrors["dataUnit"] = "Field belum diisi";
        }

        if (controls) {
            for (const [key, data] of Object.entries(controls)) {
                if (data) {
                    const message = this.validateEmptyValue(data);
                    if (message) {
                        newErrors[key] = message;
                    }
                }
            }
        }
        console.log("newErrors: ", newErrors);
        return newErrors;
    }

    getBaseUnitKey = (item) => {
        return [
            item?.dataVariant?.kodeVariant || "",
            item?.dataWarna?.kodeWarna || "",
            item?.tahunProduksi || "",
        ].join("-");
    }

    getVariantYearKey = (item) => {
        return [
            item?.dataVariant?.kodeVariant || "",
            item?.tahunProduksi || "",
        ].join("-");
    }

    isSameBaseUnit = (itemA, itemB) => {
        return this.getBaseUnitKey(itemA) === this.getBaseUnitKey(itemB);
    }

    parseToNumber = (value) => {
        const parsed = Number(value);
        return Number.isNaN(parsed) ? 0 : parsed;
    }

    isRangeOverlap = (startA, endA, startB, endB) => {
        const parsedStartA = this.parseToNumber(startA);
        const parsedEndA = this.parseToNumber(endA);
        const parsedStartB = this.parseToNumber(startB);
        const parsedEndB = this.parseToNumber(endB);

        const [minA, maxA] = parsedStartA <= parsedEndA ? [parsedStartA, parsedEndA] : [parsedEndA, parsedStartA];
        const [minB, maxB] = parsedStartB <= parsedEndB ? [parsedStartB, parsedEndB] : [parsedEndB, parsedStartB];

        return minA <= maxB && minB <= maxA;
    }

    isCreditRangeConflict = (itemA, itemB) => {
        const dpOverlap = this.isRangeOverlap(itemA?.dpAwal, itemA?.dpAkhir, itemB?.dpAwal, itemB?.dpAkhir);
        const tenorOverlap = this.isRangeOverlap(itemA?.tenorAwal, itemA?.tenorAkhir, itemB?.tenorAwal, itemB?.tenorAkhir);

        return dpOverlap && tenorOverlap;
    }

    getComparableExistingData = () => {
        const currentData = this.props.controls.dataUnit.value || [];
        if (R.isNil(this.state.selectedData)) {
            return currentData;
        }

        return currentData.filter((_, index) => index !== this.state.selectedIndex);
    }

    hasCashConflict = (incomingData, existingData) => {
        return incomingData.some((incoming) =>
            existingData.some((existing) =>
                this.getBaseUnitKey(incoming) === this.getBaseUnitKey(existing)
            )
        );
    }

    hasCreditConflict = (incomingData, existingData) => {
        return incomingData.some(item=> {
            return existingData.some(existingItem => this.isSameBaseUnit(item, existingItem) && this.isCreditRangeConflict(item, existingItem))
        })
    }

    validateBeforeAddUnit = (incomingData) => {
        const tab = (this.props.controls.promoType?.value?.value || "").toLowerCase();
        const existingData = this.getComparableExistingData();

        if (tab === "cash" && this.hasCashConflict(incomingData, existingData)) {
            return {
                valid: false,
                message: "Terdapat kode varian, warna, dan tahun produksi yang sama, mohon dicek kembali data tersebut.",
            };
        }

        if (tab === "credit" && this.hasCreditConflict(incomingData, existingData)) {
            return {
                valid: false,
                message: "Terdapat kode varian, warna, tahun produksi, dp, dan tenor yang sama, mohon dicek kembali data tersebut.",
            };
        }

        return {valid: true};
    }

    validateEmptyValue(data) {
        if (R.and(data.mandatory, R.or(!data.value, R.isEmpty(data.value)))) {
            return "Field belum diisi";
        }

        return null;
    }

    handleAddVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            addVisible: !prevValue.addVisible,
        }))
    }

    handleCloseAddUnit = () =>{
        this.setState({selectedData: null})
        this.handleAddVisibility()
    }

    handleUploadVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            uploadVisible: !prevValue.uploadVisible,
        }))
    }

    handleDeleteUnit = (rowIndex) => {
        const afterRemove = R.remove(rowIndex, 1, this.props.controls.dataUnit.value);
        this.props.setValue("dataUnit", afterRemove);
        this.setState((prevState) => ({
            pagination: {
                ...prevState.pagination,
                totalData: afterRemove?.length || 0,
            }
        }));
    }

    handleAddUnit = (dataList) => {
        const validationResult = this.validateBeforeAddUnit(dataList);
        if (!validationResult.valid) {
            this.handleAlertVisibility(validationResult.message);
            return;
        }

        const currentData = this.props.controls.dataUnit.value || [];
        if (R.isNil(this.state.selectedData)) {
            const result = [
                ...currentData,
                ...dataList,
            ];
            this.props.setValue("dataUnit", result);
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    totalData: result?.length || 0,
                }
            }));
            this.handleAddVisibility();
        } else {
            let index = this.state.selectedIndex;
            const updatedData = [...currentData];
            
            updatedData.splice(index, 1, ...dataList);
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    totalData: updatedData?.length || 0,
                }
            }));

            this.props.setValue("dataUnit", updatedData);

            this.setState({
                selectedData: null,
                selectedIndex: null,
            });

            this.handleAddVisibility();
        }
    };


    fetchData = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getByIdMasterPromo,
            setError: this.props.setError,
            menuName: "Master Promo",
            args: {
                promoId: this.props.initialValues?.id,
                userId: this.props.userId
            },
        })

        if (res.ok && res.data.status === HttpStatus.FAILED) {
            this.props.onClickClose();
        }

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            const {data} = res.data;
            this.props.setValue("promoId", data?.promoId);
            this.props.setValue("promoName", data?.namaPromo);
            this.props.setValue("startDate", data?.startDatePromo);
            this.props.setValue("endDate", data?.endDatePromo);
            this.props.setValue("gracePeriod", data?.gracePeriod);
            this.props.setValue("applied", data?.cabangBerlaku);
            let listCabang = [];
            if (!R.isNil(data?.cabang) && !R.isEmpty(data?.cabang)) {
                listCabang = data?.cabang.map((item) => mapToObjectDDL(item.namaDealer, item.kodeCabang))
            }
            this.props.setValue("cabang", listCabang);
            const ddlWilayah = data?.wilayah ? mapToObjectDDL(data?.wilayah?.value || '', data?.wilayah?.key || '') : null;
            this.props.setValue("wilayah", ddlWilayah);
            this.props.setValue("leasingId", mapToObjectDDL(data?.leasing?.leasingName, data?.leasing?.leasingId));
            this.props.setValue("status", data?.status);
            this.props.setValue("promoType", mapToObjectDDL(data?.tipePromo, data?.tipePromo));
            let listDataUnit = [];
            if (!R.isNil(data?.detailPromo) && !R.isEmpty(data?.detailPromo)) {
                listDataUnit = data?.detailPromo.map((item) => {
                    const {warna, variant, credit, ...filtered} = item;
                    return {
                        dataVariant: {
                            kodeVariant: variant?.kodeVariant,
                            namaVariant: variant?.namaVariant
                        },
                        dataWarna: {
                            id: warna?.warnaResponseDTO?.id,
                            kodeWarna: warna?.warnaResponseDTO?.kodeWarna,
                            namaWarnaKomersil: warna?.warnaResponseDTO?.namaWarnaKomersil
                        },
                        ...filtered,
                        ...credit
                    }
                })
            }
            this.setState((prevState) => ({
                loadLeasing: true,
                pagination: {
                    ...prevState.pagination,
                    totalData: data?.detailPromo?.length || 0,
                }
            }));
            this.props.setValue("dataUnit", listDataUnit);
        }
    }

    handleLoadLeasingState = () => {
        this.setState({
            loadLeasing: false
        })
    }

    fetchDataPreviewId = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPreviewIdMasterPromo,
            setError: this.props.setError,
            menuName: "Master Promo",
            args: null,
        })

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.props.setValue("promoId", res.data.data);
            this.props.setValue("promoName", null);
            this.props.setValue("id", null);
        }
    }

    handleDownloadTemplate = async () => {
        const promoType = this.props.controls.promoType?.value;
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA_FILE").getTemplateExcelMasterPromo,
            setError: this.props.setError,
            menuName: "Master Promo",
            args: {
                promoType: promoType?.value.toString().toUpperCase()
            },
        })

        if (res.ok) {
            const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `TEMPLATE_UPLOAD_PROMO_${promoType?.value.toString().toUpperCase()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }
    }

    handleSelectFile = () => {
        this.fileInputRef.current.click();
    };

    handleFileChange = (event) => {
        const file = event.target.files[0]; 
        if (file) {
            this.setState({file: file});
        }
    };

    handleValidateSubmit = async () => {
        if (this.state.file) {
            this.handleTriggerLoading();

            const formData = new FormData();
            formData.append(
                "promoType",
                this.props.controls?.promoType?.value?.value
                    ?.toString()
                    ?.toUpperCase()
            );
            formData.append("file", this.state.file);

            let res = await Api.create("NAGAMAS_MASTER_DATA").uploadExcelDataMasterPromo(formData);

            if (res.ok && res.data.status === HttpStatus.FAILED) {
                this.handleTriggerLoading();
                this.handleAlertVisibility(
                    "Terdapat kesalahan pengisian data upload. Mohon diperbaiki dan upload kembali kemudian.",
                    "error_log"
                );
                document.getElementById("inputFile").value = "";
                this.setState({ file: null });
                return;
            }

            if (res.ok) {
                const prevDataUnit = this.props.controls.dataUnit.value || [];

                const listDataUnit = res.data.data?.map((item) => {
                    const { warna, variant, credit, ...filtered } = item;

                    return {
                        dataVariant: {
                            kodeVariant: variant?.kodeVariant,
                            namaVariant: variant?.namaVariant,
                        },
                        dataWarna: {
                            id: warna?.warnaResponseDTO?.id,
                            kodeWarna: warna?.warnaResponseDTO?.kodeWarna,
                            namaWarnaKomersil:
                                warna?.warnaResponseDTO?.namaWarnaKomersil,
                        },
                        ...filtered,
                        ...credit,
                    };
                }) || [];

                const updatedDataUnit = [...prevDataUnit, ...listDataUnit];
                this.props.setValue("dataUnit", updatedDataUnit);
                this.setState((prevState) => ({
                    pagination: {
                        ...prevState.pagination,
                        totalData: updatedDataUnit.length,
                    }
                }));

                document.getElementById("inputFile").value = "";
                this.setState({ file: null });

                this.handleTriggerLoading();
                this.handleUploadVisibility();
            }
        }
    };

    onClickClose = () => {
        this.props.onClickClose();
        this.props.setValue("dataUnit", []);
    };

    handleSort = (sortOrder) => {
      if (!sortOrder || !sortOrder.direction) {
        this.setState({ sortOrder: null }); 
        return;
      }

      this.setState({ sortOrder });
    };

    getSortedData = () => {
      const { sortOrder } = this.state;
      let data = [...this.props.controls.dataUnit.value];

      if (!sortOrder) {
        return _.sortBy(data || [], [
          (item) => item.dataVariant?.kodeVariant || "",
          (item) => item.tahunProduksi || 0,
          (item) => item.dataWarna?.kodeWarna || "",
          (item) => item.dpAwal || 0,
          (item) => item.tenorAwal || 0,
        ]);
      }

      data.sort((a, b) => {
        let valA, valB;
        if (sortOrder.name === "kodeVariant") {
          valA = a.dataVariant?.kodeVariant || "";
          valB = b.dataVariant?.kodeVariant || "";
        } else if (sortOrder.name === "kodeWarna") {
          valA = a.dataWarna?.kodeWarna || "";
          valB = b.dataWarna?.kodeWarna || "";
        } else {
          valA = a[sortOrder.name] || "";
          valB = b[sortOrder.name] || "";
        }

        if (valA < valB) return sortOrder.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortOrder.direction === "asc" ? 1 : -1;

        if (sortOrder.name === "kodeVariant") {
          const warnaA = a.dataWarna?.kodeWarna || "";
          const warnaB = b.dataWarna?.kodeWarna || "";
          if (warnaA < warnaB) return -1;
          if (warnaA > warnaB) return 1;
        }

        return 0;
      });

      return data;
    };

    handleAlertVisibility = (content, type) => {
        this.setState((prevValue) => ({
            ...prevValue,
            alert: {
                visible: !prevValue.alert.visible,
                content: content,
                type: type
            },
        }))
    }

    handleDownloadLogError = async () => {
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA_FILE").downloadLogErrorMasterPromo,
            menuName: "Master Promo",
            setError: this.props.setError,
            args:{
                promoType: this.props.controls.promoType?.value?.value
            }
        });
        if (res.ok) {
            const blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
    
            saveAs(blob, `LogErrorMasterPromo.xlsx`);
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <SimpleModal
                title="Master Promo Detail"
                visible={this.props.visible}
                onClickClose={this.onClickClose}
                content={
                    <ModalContainer>
                        <MasterPromoHeader
                            {...this.props}
                            isLoadLeasing={this.state.loadLeasing}
                            onSuccessLoadLeasing={this.handleLoadLeasingState}
                            triggerLoading={this.handleTriggerLoading}
                        />
                        <SimpleDataTable
                          key={`${pagination.totalData}-${pagination.page}`}
                          data={this.getSortedData()}
                          columns={this.state.tableColumn}
                          toCount={pagination.totalData}
                          rowsPerPage={pagination.limit}
                          page={pagination.page - 1}
                          options={{...defaultTableChangePromo(this.handleSort, this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                        />
                        {this.props.errors?.dataUnit && (
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4 style={{color: "red"}}>{this.props.errors?.dataUnit}</h4>
                            </div>
                        )}
                        <FlexView style={{justifyContent: "end", marginTop: "10px"}}>
                            {this.props.activityType === ACTIVITY_TYPE.VIEW ? (
                                <SimpleButton
                                    text="Keluar"
                                    onClick={this.props.onClickClose}
                                />
                            ) : (
                                <>
                                    <SimpleButton
                                        text="Tambah"
                                        onClick={this.handleAddVisibility}
                                    />
                                    <SimpleButton
                                        text="Upload"
                                        onClick={() => {
                                            if(!this.props.controls.promoType?.value){
                                                this.handleAlertVisibility("Harap pilih Tipe Promo terlebih dahulu.")
                                                return;
                                            }
                                            this.handleUploadVisibility()
                                        }}
                                    />
                                    <SimpleButton
                                        text="Simpan"
                                        onClick={this.handleSubmit}
                                    />
                                </>
                            )}

                        </FlexView>
                        {this.state.addVisible && (
                            <MasterPromoTambahUnit
                                {...this.props}
                                initialValue={this.state.selectedData}
                                visible={this.state.addVisible}
                                onClickClose={this.handleCloseAddUnit}
                                onSubmit={this.handleAddUnit}
                            />
                        )}
                        {this.state.uploadVisible && (
                            <SimpleModal
                                title="Upload Detail Promo"
                                visible={this.state.uploadVisible}
                                onClickClose={this.handleUploadVisibility}
                                styles={{width: "50%"}}
                                content={
                                    <ModalContainer>
                                        <FlexView column>
                                            <div>
                                                <p>
                                                    Petunjuk untuk melakukan upload detail promo
                                                </p>
                                                <p>
                                                    1. Gunakan template yang sudah tersedia.
                                                </p>
                                                <p>
                                                    2. Masukkan data sesuai Format.
                                                </p>
                                                <p>
                                                    3. Gunakan tombol validate and submit untuk memeriksa data.
                                                </p>
                                                <SimpleInput readOnly value={this.state.file?.name}/>
                                            </div>
                                            <FlexView style={{justifyContent: "center", marginTop: "20px"}}>
                                                <SimpleButton
                                                    text="DOWNLOAD TEMPLATE"
                                                    onClick={this.handleDownloadTemplate}
                                                />
                                                <input
                                                    id="inputFile"
                                                    type="file"
                                                    ref={this.fileInputRef}
                                                    onChange={this.handleFileChange}
                                                    hidden
                                                />
                                                <SimpleButton
                                                    text="PILIH FILE"
                                                    onClick={this.handleSelectFile}
                                                />
                                                <SimpleButton
                                                    text="VALIDATE AND SUBMIT"
                                                    onClick={this.handleValidateSubmit}
                                                />
                                            </FlexView>
                                        </FlexView>
                                    </ModalContainer>
                                }
                            />
                        )}

                        {
                            this.state.alert.visible && (
                                <SimpleAlert
                                    title="Information"
                                    visible={this.state.alert?.visible}
                                    onClickClose={() => this.handleAlertVisibility()}
                                    content={this.state.alert?.content}
                                    additionalButtons={
                                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                           <SimpleButton
                                              text="OK"
                                              onClick={() => {
                                                this.handleAlertVisibility();
                                              }}
                                            />
                                            
                                           {this.state.alert.type === "error_log" && 
                                                <SimpleButton
                                                  text="Download Log Error"
                                                  onClick={() => {
                                                     this.handleDownloadLogError();
                                                  }}
                                                />
                                            }
                                        </FlexView>
                                    }
                                />
                            )
                        }

                        {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                    </ModalContainer>
                }
            />
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(withFormGroup(MasterPromoModifying));
